import { apiClient } from '@/shared/api/client'

export async function createQuotation(payload) {
  const response = await apiClient.post('/sales/quotations', payload)

  return response.data
}

export async function getNextQuoteNumber() {
  const response = await apiClient.get('/sales/quotations/next-number')

  return response.data
}

export async function getQuotations(params = {}) {
  const response = await apiClient.get('/sales/quotations', {
    params,
  })

  return response.data
}

export async function getQuotationStats(params = {}) {
  const response = await apiClient.get('/sales/quotations/stats', {
    params,
  })
  return response.data
}

export async function getQuotationById(id) {
  const response = await apiClient.get(`/sales/quotations/${id}`)

  return response.data
}

export async function getQuotationByLeadId(leadId) {
  try {
    const response = await apiClient.get(`/sales/quotations/lead/${leadId}`)
    return response.data
  } catch (error) {
    if (error.response?.status === 404) return null
    throw error
  }
}

export async function exportQuotation(id) {
  const response = await apiClient.get(`/sales/quotations/${id}/export`, {
    responseType: 'blob',
  })

  return response.data
}

export async function sendQuotation(id, emailData) {
  const response = await apiClient.post(
    `/sales/quotations/${id}/send`,
    emailData,
  )

  return response.data
}

export async function getQuotationEmailPreview(id) {
  const response = await apiClient.get(`/sales/quotations/${id}/email-preview`)

  return response.data
}

export async function updateQuotation(id, payload) {
  const response = await apiClient.patch(`/sales/quotations/${id}`, payload)

  return response.data
}

export async function deleteQuotation(id) {
  const response = await apiClient.delete(`/sales/quotations/${id}`)

  return response.data
}

export function triggerPdfDownload(blobOrUrl, fileName = 'quotation.pdf') {
  if (typeof blobOrUrl === 'string' && blobOrUrl.trim()) {
    const API_BASE =
      import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1'

    const SERVER_BASE = API_BASE.replace('/api/v1', '')

    const fullUrl = blobOrUrl.startsWith('http')
      ? blobOrUrl
      : `${SERVER_BASE}${blobOrUrl}`

    const link = document.createElement('a')
    link.href = fullUrl
    link.download = fileName
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else if (blobOrUrl instanceof Blob) {
    const url = window.URL.createObjectURL(blobOrUrl)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
}
